// dependencies
import React from "react";

import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Icon from "./Icon";

// styles
import css from "./Icon.module.scss";
import { IconCompatibilityProps } from "./index";

const CompatibilityWrapper = (props: IconCompatibilityProps) => {
	const { className = "", size = 18, name = "", type = "fontawesome", icon, style } = props;

	// new component implementation
	if (icon) {
		const iconSize = typeof size === "number" ? undefined : (size as "small" | "regular");
		return <Icon className={className} size={iconSize} icon={icon as IconDefinition} />;
	}

	// old component implementation
	else {
		let icon: any = "";
		switch (type) {
			case "awesome":
			case "fontawesome": {
				icon = <i style={{ fontSize: size }} className={`${css.awesomeIcon} awesome-icon fa fa-${name}`} />;

				break;
			}

			case "fa5": {
				/*
                font awesome did sizes weird, so these are the possible sizes:
                xs, sm, 1x, lg, 2x, 3x, 4x, ..., 10x
            */
				// Ensure name is valid before passing to FontAwesome
				if (name && (Array.isArray(name) || (typeof name === "object" && name.iconName))) {
					icon = <FontAwesomeIcon icon={name} size={typeof size === "string" ? (size as SizeProp) : "1x"} />;
				} else {
					// Fallback for invalid or missing icon names
					icon = (
						<div
							style={{
								width: typeof size === "number" ? size : 16,
								height: typeof size === "number" ? size : 16,
							}}
						/>
					);
				}
				break;
			}

			case "material": {
				const iconName = name.replace(" ", "_");
				icon = (
					<i style={{ fontSize: size }} className={`${css.materialIcons} material-icons`}>
						{iconName}
					</i>
				);
				break;
			}

			default:
				return <div />;
		}

		return (
			<div
				data-testid={props["data-testid"] || name?.iconName}
				className={`${css.cpIcon} cp-icon ${className}`}
				style={{ width: size, height: size, ...style }}
			>
				{icon}
			</div>
		);
	}
};

export default CompatibilityWrapper;
